<script>
export default {
  props: {
    data: Array,
  },
  render() {
    const columns = [
      { prop: 'createTime', label: '操作时间' },
      {
        prop: 'creatorName',
        label: '操作人',
        format: (val, row) => `${row.creator} ${val}`,
      },
      { prop: 'note', label: '操作内容' },
    ]
    return <HxTable showIndexCol={true} data={this.data} columns={columns} />
  },
}
</script>
